import { createAction } from "redux-starter-kit";
import { normalize } from "normalizr";
import { debounce } from "lodash";
import { addEntities } from "../../entities";
import {
  FETCH_QUERY_DEBTORS_FAILURE,
  FETCH_QUERY_DEBTORS_REQUEST,
  FETCH_QUERY_DEBTORS_SUCCESS
} from "../types";

const debounced = debounce(
  async (dispatch, schema, api, limit, offset, ordering, filters) => {
    dispatch(
      createAction(FETCH_QUERY_DEBTORS_REQUEST)({
        ordering,
        limit,
        offset,
        filters
      })
    );
    const response = await api.debtors.getDebtors(
      undefined,
      ordering,
      limit,
      offset,
      filters
    );
    const data = normalize(response.results, [schema.debtors]);
    dispatch(addEntities(data.entities));
    dispatch(
      createAction(FETCH_QUERY_DEBTORS_SUCCESS)({
        ids: data.result,
        count: response.count,
        limit,
        offset,
        ordering,
        filters
      })
    );
    return response;
  },
  1000,
  { trailing: true }
);

const queryDebtors = (ordering, limit, offset, filters = {}) => async (
  dispatch,
  getState,
  { api, schema }
) => {
  try {
    await debounced(dispatch, schema, api, limit, offset, ordering, filters);
  } catch (err) {
    dispatch(createAction(FETCH_QUERY_DEBTORS_FAILURE)(err));
    throw err;
  }
};

export default queryDebtors;
